<div class="bg-white">
	<div class="border-bottom p-4">
		<h3 class="pt-2">KYC Business</h3>
	</div>

	<div class="p-4">
		<div class="page-1 w-100">
			<form class="row" *ngIf="formGroup" [formGroup]="formGroup">
				<div class="mb-3">
					<div class="form-group">
						<div class="row">

							<div class="col-md-2">
								<label>Business Id</label>
								<input type="text" [formControl]="getFormControl('BusinessId')" class="form-control">
							</div>

							<div class="col-md-6">
								<label>Business Name</label>
								<input type="text" [formControl]="getFormControl('BusinessName')" class="form-control">
							</div>

							<div class="col-md-3">
								<label>Type</label>
								<select (change)="showWarnning()" class="form-control form-select"
									[formControl]="getFormControl('Type')">
									<option *ngFor="let type of typeValues" [value]="type">{{ type }}</option>
								</select>
								<small class="text-danger" *ngIf="formValidator.formErrors.Type">
									{{ formValidator.formErrors.Type }}
								</small>
							</div>

						</div>

						<div class="row">

							<div class="col-md-3">
								<label>Status</label>
								<select (change)="showWarnning()" class="form-control form-select"
									[formControl]="getFormControl('Status')">
									<option *ngFor="let status of statusValues" [value]="status">{{ status }}</option>
								</select>
								<small class="text-danger" *ngIf="formValidator.formErrors.Status">
									{{ formValidator.formErrors.Status }}
								</small>
							</div>

							<div *ngIf="businessData.Type === 'Company'" class="col-md-3">
								<label>Tax Number</label>
								<input (keyup)="formatTaxNumber()" type="text" [formControl]="getFormControl('TaxNumber')"
									class="form-control">
								<small class="text-danger" *ngIf="formValidator.formErrors.TaxNumber">
									{{ formValidator.formErrors.TaxNumber }}
								</small>
							</div>

							<div *ngIf="businessData.Type === 'Company'" class="col-md-3">
								<label>Legal Name</label>
								<input (keyup)="showWarnning()" type="text" [formControl]="getFormControl('LegalName')"
									class="form-control">
								<small class="text-danger" *ngIf="formValidator.formErrors.LegalName">
									{{ formValidator.formErrors.LegalName }}
								</small>
							</div>

							<div *ngIf="businessData.Type === 'Individual'" class="col-md-3">
								<label>National Id</label>
								<input (keyup)="showWarnning()" type="text" [formControl]="getFormControl('NationalId')"
									class="form-control">
								<small class="text-danger" *ngIf="formValidator.formErrors.NationalId">
									{{ formValidator.formErrors.NationalId }}
								</small>
							</div>


							<div *ngIf="businessData.Type === 'Individual'" class="col-md-3">
								<label>National Name</label>
								<input (keyup)="showWarnning()" type="text"
									[formControl]="getFormControl('NationalName')" class="form-control">
								<small class="text-danger" *ngIf="formValidator.formErrors.NationalName">
									{{ formValidator.formErrors.NationalName }}
								</small>
							</div>

						</div>
					</div>

					<div class="row" *ngIf="businessData.Type === 'Company'">
						<div class="form-group mb-3 col-md-6">
							<label class="row">{{ 'Sellers.Products.DownloadCommercialRegister' | translate }}
							</label>
							<img class="row img-fluid img-thumbnail" [src]="getLink('commercialRegister')"
								alt="No Image Uploaded">
							<button (click)=" download('commercialRegister')" class="row btn btn-sm btn-success ms-2">
								{{ 'Sellers.Products.Download' | translate }}
							</button>
						</div>

						<div class="form-group mb-3 col-md-6">
							<label class="row">{{ 'Sellers.Products.DownloadTaxCard' | translate }} </label>
							<img class="row img-fluid img-thumbnail" [src]="getLink('taxNumber')"
								alt="No Image Uploaded">
							<button (click)="download('taxNumber')" class="row btn btn-sm btn-success ms-2">
								{{ 'Sellers.Products.Download' | translate }}
							</button>
						</div>
					</div>

					<div *ngIf="businessData.Type === 'Individual'" class="row">
						<div class="form-group mb-3 col-md-6">
							<label class="row">{{ 'Sellers.Products.BusinessOwnerNationalIdNumber' | translate }}
							</label>
							<img class="row img-fluid img-thumbnail" [src]="getLink('personalIdFront')"
							alt="No Image Uploaded">
							<button (click)="download('personalIdFront')" class="row btn btn-sm btn-success ms-2">
								{{ 'Sellers.Products.Download' | translate }}
							</button>
						</div>

						<div class="form-group mb-3 col-md-6">
							<label class="row">{{ 'Sellers.Products.BusinessOwnerNationalIdNumber' | translate }}
							</label>
							<img class="row img-fluid img-thumbnail" [src]="getLink('personalIdBack')"
							alt="No Image Uploaded">
							<button (click)="download('personalIdBack')" class="row btn btn-sm btn-success ms-2">
								{{ 'Sellers.Products.Download' | translate }}
							</button>
						</div>
					</div>

				</div>
			</form>
		</div>
	</div>

	<div class="border-top p-4">
		<div class="ms-auto col-auto">
			<button (click)="submit()" class="btn btn-primary">
				Submit
			</button>
		</div>
		<br>
		<div class="d-flex justify-content-between">
			<button [disabled]="!prevId" (click)="nextOrPrevious('prev')" class="btn btn-primary mb-2 col-md-2">
				Previous Business
			</button>
			<button [disabled]="!nextId" (click)="nextOrPrevious('next')"
				class="btn btn-primary mb-2 col-md-2 float-end">
				Next Business
			</button>
		</div>
	</div>

</div>
